
/**
 * @sveltech/routify 1.9.10
 * File generated Wed Dec 31 1969 16:00:00 GMT-0800 (Pacific Standard Time)
 */

export const __version = "1.9.10"
export const __timestamp = "1970-01-01T00:00:00.000Z"

//buildRoutes
import { buildClientTree } from "@sveltech/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "ownMeta": {
    "bundle": true
  },
  "absolutePath": "src/pages",
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": true,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/_fallback",
      "id": "__fallback",
      "component": () => import('./_.js').then(m => m.__fallback)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": true,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/",
      "id": "__layout",
      "component": () => import('./_.js').then(m => m.__layout)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin",
          "id": "_admin__layout",
          "component": () => import('./_.js').then(m => m._admin__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/._router",
          "id": "_admin___router",
          "component": () => import('./_.js').then(m => m._admin___router)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/earnings",
          "id": "_admin_earnings",
          "component": () => import('./_.js').then(m => m._admin_earnings)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/index",
          "id": "_admin_index",
          "component": () => import('./_.js').then(m => m._admin_index)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/payments",
          "id": "_admin_payments",
          "component": () => import('./_.js').then(m => m._admin_payments)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/payments_history",
          "id": "_admin_payments_history",
          "component": () => import('./_.js').then(m => m._admin_payments_history)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/pool_stats",
          "id": "_admin_pool_stats",
          "component": () => import('./_.js').then(m => m._admin_pool_stats)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/pps",
          "id": "_admin_pps",
          "component": () => import('./_.js').then(m => m._admin_pps)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/router",
          "id": "_admin_router",
          "component": () => import('./_.js').then(m => m._admin_router)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/users",
          "id": "_admin_users",
          "component": () => import('./_.js').then(m => m._admin_users)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {
        "prerender": false
      },
      "meta": {
        "prerender": false,
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/admin"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth",
          "id": "_auth__reset",
          "component": () => import('./_.js').then(m => m._auth__reset)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/forgot",
          "id": "_auth_forgot",
          "component": () => import('./_.js').then(m => m._auth_forgot)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/google",
          "id": "_auth_google",
          "component": () => import('./_.js').then(m => m._auth_google)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/login",
          "id": "_auth_login",
          "component": () => import('./_.js').then(m => m._auth_login)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/logout",
          "id": "_auth_logout",
          "component": () => import('./_.js').then(m => m._auth_logout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/register",
          "id": "_auth_register",
          "component": () => import('./_.js').then(m => m._auth_register)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/auth/reset-password/:token",
              "id": "_auth_resetPassword__token",
              "component": () => import('./_.js').then(m => m._auth_resetPassword__token)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/reset-password"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/auth/verify",
          "id": "_auth_verify",
          "component": () => import('./_.js').then(m => m._auth_verify)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/auth"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/base",
          "id": "_base__reset",
          "component": () => import('./_.js').then(m => m._base__reset)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/base/bbp/index",
              "id": "_base_bbp_index",
              "component": () => import('./_.js').then(m => m._base_bbp_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/base/bbp"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/base"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp",
          "id": "_bbp__reset",
          "component": () => import('./_.js').then(m => m._bbp__reset)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/admin/index",
              "id": "_bbp_admin_index",
              "component": () => import('./_.js').then(m => m._bbp_admin_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/admin"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/auth/google",
              "id": "_bbp_auth_google",
              "component": () => import('./_.js').then(m => m._bbp_auth_google)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/auth"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/dashboard/index",
              "id": "_bbp_dashboard_index",
              "component": () => import('./_.js').then(m => m._bbp_dashboard_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/dashboard"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/dashboard-demo",
          "id": "_bbp_dashboardDemo",
          "component": () => import('./_.js').then(m => m._bbp_dashboardDemo)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/forgot",
          "id": "_bbp_forgot",
          "component": () => import('./_.js').then(m => m._bbp_forgot)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/index",
          "id": "_bbp_index",
          "component": () => import('./_.js').then(m => m._bbp_index)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/login",
          "id": "_bbp_login",
          "component": () => import('./_.js').then(m => m._bbp_login)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/orders/index",
              "id": "_bbp_orders_index",
              "component": () => import('./_.js').then(m => m._bbp_orders_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/orders"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/profile/index",
              "id": "_bbp_profile_index",
              "component": () => import('./_.js').then(m => m._bbp_profile_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/profile"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/register",
          "id": "_bbp_register",
          "component": () => import('./_.js').then(m => m._bbp_register)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/reset-password/:token",
              "id": "_bbp_resetPassword__token",
              "component": () => import('./_.js').then(m => m._bbp_resetPassword__token)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/reset-password"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/start",
          "id": "_bbp_start",
          "component": () => import('./_.js').then(m => m._bbp_start)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/verify",
          "id": "_bbp_verify",
          "component": () => import('./_.js').then(m => m._bbp_verify)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/bbp/wallet/index",
              "id": "_bbp_wallet_index",
              "component": () => import('./_.js').then(m => m._bbp_wallet_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/bbp/wallet"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/bbp"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/calculator",
          "id": "_calculator__layout",
          "component": () => import('./_.js').then(m => m._calculator__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/calculator/index",
          "id": "_calculator_index",
          "component": () => import('./_.js').then(m => m._calculator_index)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/calculator"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/earnings",
          "id": "_earnings__layout",
          "component": () => import('./_.js').then(m => m._earnings__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/earnings/index",
          "id": "_earnings_index",
          "component": () => import('./_.js').then(m => m._earnings_index)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/earnings"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "prerender": false
      },
      "meta": {
        "prerender": false,
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/index",
      "id": "_index",
      "component": () => import('./_.js').then(m => m._index)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/payments",
          "id": "_payments__layout",
          "component": () => import('./_.js').then(m => m._payments__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/payments/index",
          "id": "_payments_index",
          "component": () => import('./_.js').then(m => m._payments_index)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {
        "prerender": false
      },
      "meta": {
        "prerender": false,
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/payments"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/:coin",
              "id": "_pool__coin__layout",
              "component": () => import('./_.js').then(m => m._pool__coin__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/:coin/found-blocks",
              "id": "_pool__coin_foundBlocks",
              "component": () => import('./_.js').then(m => m._pool__coin_foundBlocks)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/:coin/index",
              "id": "_pool__coin_index",
              "component": () => import('./_.js').then(m => m._pool__coin_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/pool/:coin"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/dashboard",
              "id": "_pool_dashboard__layout",
              "component": () => import('./_.js').then(m => m._pool_dashboard__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/dashboard/index",
              "id": "_pool_dashboard_index",
              "component": () => import('./_.js').then(m => m._pool_dashboard_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/pool/dashboard"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/pool/index",
          "id": "_pool_index",
          "component": () => import('./_.js').then(m => m._pool_index)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/workers",
              "id": "_pool_workers__layout",
              "component": () => import('./_.js').then(m => m._pool_workers__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": false,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/pool/workers/index",
              "id": "_pool_workers_index",
              "component": () => import('./_.js').then(m => m._pool_workers_index)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/pool/workers"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/pool"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/profile",
          "id": "_profile__layout",
          "component": () => import('./_.js').then(m => m._profile__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/profile/edit",
          "id": "_profile_edit",
          "component": () => import('./_.js').then(m => m._profile_edit)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/profile/index",
          "id": "_profile_index",
          "component": () => import('./_.js').then(m => m._profile_index)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/profile/security",
          "id": "_profile_security",
          "component": () => import('./_.js').then(m => m._profile_security)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {
        "prerender": false
      },
      "meta": {
        "prerender": false,
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/profile"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting",
          "id": "_setting__layout",
          "component": () => import('./_.js').then(m => m._setting__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/._router",
          "id": "_setting___router",
          "component": () => import('./_.js').then(m => m._setting___router)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/index",
          "id": "_setting_index",
          "component": () => import('./_.js').then(m => m._setting_index)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/notifications",
          "id": "_setting_notifications",
          "component": () => import('./_.js').then(m => m._setting_notifications)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/payments",
          "id": "_setting_payments",
          "component": () => import('./_.js').then(m => m._setting_payments)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "prerender": false
          },
          "meta": {
            "prerender": false,
            "preload": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/router",
          "id": "_setting_router",
          "component": () => import('./_.js').then(m => m._setting_router)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/watchers",
          "id": "_setting_watchers",
          "component": () => import('./_.js').then(m => m._setting_watchers)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": false,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/setting/worker-groups",
          "id": "_setting_workerGroups",
          "component": () => import('./_.js').then(m => m._setting_workerGroups)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {
        "prerender": false
      },
      "meta": {
        "prerender": false,
        "preload": false,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/setting"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/watcher",
          "id": "_watcher__layout",
          "component": () => import('./_.js').then(m => m._watcher__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/watcher/:token",
          "id": "_watcher__token",
          "component": () => import('./_.js').then(m => m._watcher__token)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/watcher"
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "bundle": true,
    "preload": false,
    "prerender": true,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true,
    "$$bundleId": "_.js"
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

